module.exports = __webpack_public_path__ + "img/icon_secChoice_01.1c4f818f.png";